import { TUTORIAL_REPEAT_STORAGE_KEYS, TUTORIAL_SEEN_STORAGE_KEYS } from './constants';

const hasWindow = () => typeof window !== 'undefined';
const normalizeScopeKey = (scopeKey = 'global') => String(scopeKey || 'global').trim() || 'global';
const buildScopedStorageKey = (key, scopeKey) => `${key}:${normalizeScopeKey(scopeKey)}`;

export const readTutorialSeen = (flowId, scopeKey = 'global') => {
  if (!hasWindow()) return false;
  const key = TUTORIAL_SEEN_STORAGE_KEYS[flowId];
  if (!key) return false;
  const scopedKey = buildScopedStorageKey(key, scopeKey);
  if (window.localStorage.getItem(scopedKey) === 'true') return true;

  // Keep the previous global memory only for the original base company.
  return normalizeScopeKey(scopeKey) === 'default' && window.localStorage.getItem(key) === 'true';
};

export const saveTutorialSeen = (flowId, seen = true, scopeKey = 'global') => {
  if (!hasWindow()) return;
  const key = TUTORIAL_SEEN_STORAGE_KEYS[flowId];
  if (!key) return;
  const value = seen ? 'true' : 'false';
  window.localStorage.setItem(buildScopedStorageKey(key, scopeKey), value);
  if (normalizeScopeKey(scopeKey) === 'default') {
    window.localStorage.setItem(key, value);
  }
};

export const readUnitModalTutorialRepeatEnabled = () => {
  if (!hasWindow()) return true;
  return window.localStorage.getItem(TUTORIAL_REPEAT_STORAGE_KEYS.unitModal) !== 'false';
};

export const saveUnitModalTutorialRepeatEnabled = (enabled) => {
  if (!hasWindow()) return;
  window.localStorage.setItem(TUTORIAL_REPEAT_STORAGE_KEYS.unitModal, enabled ? 'true' : 'false');
};
